import React from "react";
import { ExitToApp, SettingsBackupRestore } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";

import { LoadingButton } from "ui";
import { NotificationBannerSlot } from "ui/NotificationBanner/NotificationBannerSlot";

import ImpersonateBanner from "fond/impersonate/ImpersonateBanner";
import { LogoLink } from "fond/topBar/LogoLink";
import { useAppSelector } from "fond/utils/hooks";
import { IconNavLink } from "fond/widgets/Link/IconNavLink";

import { Container, Title } from "./TopBar.styles";

interface IProps {
  /**
   * Flag indicating if the current styles are being saved.
   */
  isSaving?: boolean;
  onPublish(): void;
  onRevertButtonClick: () => void;
}

const TopBar: React.FC<IProps> = ({ isSaving = false, onPublish, onRevertButtonClick }: IProps) => {
  const projectId = useAppSelector((state) => state.project.projectId);

  return (
    <>
      <ImpersonateBanner />
      <NotificationBannerSlot isFixed={false} />

      <Container data-testid="styles-top-bar">
        <Box display="flex" alignItems="center" flexDirection="row" sx={{ flex: 1, overflow: "hidden" }}>
          <LogoLink />
          <Title>Styles</Title>
        </Box>
        <Box>
          <Tooltip title="Discard draft">
            <IconButton data-testid="styles-revert-button" onClick={onRevertButtonClick}>
              <SettingsBackupRestore />
            </IconButton>
          </Tooltip>
          <Tooltip title="Exit">
            <IconNavLink data-testid="styles-exit-button" to={`/project/${projectId}`}>
              <ExitToApp />
            </IconNavLink>
          </Tooltip>
          <LoadingButton
            data-testid="styles-publish-button"
            size="small"
            variant="contained"
            color="primary"
            disabled={isSaving}
            loading={isSaving}
            onClick={onPublish}
          >
            Publish
          </LoadingButton>
        </Box>
      </Container>
    </>
  );
};

export default TopBar;
